import "pixi";
import "phaser";

import { CutState } from "./cutandslide";
import * as collision from "./collision";
import * as cutandslide from "./cutandslide";
import * as i18n from "./i18n";
import * as logging from "./logging";
import * as player from "./player";

export class Tutorial {
    game: Phaser.Game;
    cutState: CutState;
    group: Phaser.Group;
    messages: { [key: string]: Message };
    phase: number;
    story: number;
    startx: number;

    constructor(game: Phaser.Game, group: Phaser.Group, levelname: string, cutState: CutState) {
        this.game = game;
        this.cutState = cutState;
        this.group = group;
        this.phase = -1;
        this.story = 0;
        this.startx = -1;

        if (levelname == "beta-1-tutorial") {
            this.phase = 0;
        }
        else if (levelname == "beta-3-cut-2") {
            this.phase = 1;
        }
        this.messages = {};

        if(this.phase == 0) {
            this.messages['move'] = new Message(this.game, this.group, i18n._("Use W,A,D (or arrow keys) to\nmove to the goal"), 480, 290);
            this.messages['jump'] = new Message(this.game, this.group, i18n._("Press W (or UP) to jump"), 250, 290);
            this.messages['move'].fadeIn();
        }
        else if(this.phase == 1) {
            this.messages['click'] = new Message(this.game, this.group, i18n._("Click here and drag right to cut"), 225, 350, 410, 350);
            this.messages['click'].fadeIn();

            this.messages['drag'] = new Message(this.game, this.group, i18n._("Drag and release here"), 625, 350, 485, 350);
            this.messages['slide'] = new Message(this.game, this.group, i18n._("Click and drag on one side\nof the line"), 650, 350);
        }

        if (this.phase > 0) {
            this.cutState.onCutStart.add(this.onCutStart, this);
            this.cutState.onCutDrawn.add(this.onCutDrawn, this);
            this.cutState.onSlideStart.add(this.onSlideStart, this);
            this.cutState.onSlideFinish.add(this.onSlideFinish, this);
            this.cutState.onCutFinish.add(this.onCutFinish, this);
            this.cutState.onSlideMaxRange.add(this.onSlideMaxRange, this);
        }

        this.logState();
    }

    logState(reason?: string) {
        const data : { [key: string]: any } = {
            phase: this.phase,
            story: this.story,
        };
        if (reason) data.reason = reason;
        logging.logAction(logging.Action.TutorialPhase, data);
    }

    enterStory(story: number, reason?: string) {
        this.story = story;
        this.logState(reason);
    }

    onCutStart(event: cutandslide.CutStartEvent) {
        if(this.phase == 0) {
            this.messages['move'].fadeOut();
            this.messages['jump'].fadeOut();
            this.enterStory(2);
        }
        if(this.phase == 1) {
            if (this.story == 0) {
                if (this.messages["click"].containsPoint(event.start)) {
                    this.messages['click'].fadeOut();
                    this.messages['drag'].fadeIn();
                    this.enterStory(1);
                }
                else {
                    event.reject();
                }
            }
        }
    }

    onCutDrawn(event: cutandslide.CutDrawnEvent) {
        if(this.phase === 1) {
            if (this.story === 1 && event.valid) {
                this.messages['drag'].fadeOut();
                this.messages['slide'].fadeIn();
                this.enterStory(2, "valid cut");
            }
            else if (this.story === 1 && !event.valid) {
                this.messages['click'].fadeIn();
                this.messages['drag'].fadeOut();
                this.enterStory(0, "invalid cut");
            }
        }
    }

    onSlideStart(){
        if(this.phase == 1){
            if(this.story == 2){
                this.messages['slide'].fadeOut();
            }
        }
    }

    onSlideMaxRange(){
        if(this.phase == 1){
            this.messages['slide'].fadeOut();
        }
    }

    onSlideFinish(){
        if (this.phase == 1) {
            if (this.story == 2) {
                if (this.cutState.status instanceof cutandslide.Cut) {
                    let [p1, p2] = this.cutState.positionLine(
                        this.cutState.status.lineStart,
                        this.cutState.status.lineSlope);

                    let dx = Math.abs((p2.x - p1.x)/2);
                    let dy = Math.abs((p2.y - p1.y)/2);

                    let cx = (p1.x < p2.x) ? p1.x + dx : p2.x + dx;
                    let cy = (p1.y < p2.y) ? p1.y + dy : p2.y + dy;

                    this.messages['confirm'] = new Message(
                        this.game, this.group,
                        i18n._("Close the gap"), cx - 140, cy);
                    this.messages['confirm'].fadeIn();
                    this.enterStory(3);
                }
            }
        }
    }

    onCutFinish(data : any){
        if(this.phase == 1){
            console.log("Finished. Data: " + data.commit);
            console.log("Story: " + this.story);

            // if they cancel a cut before clearing the story, reset the tutorial
            if (!data.commit && this.story < 4){
                console.log("Hi")
                this.messages['click'].fadeIn();
                this.messages['slide'].fadeOut();
                this.messages['confirm'].fadeOut();
                this.enterStory(0, "cancelled cut");
            }
            // otherwise proceed as normal
            else if(this.story == 3){
                this.messages['confirm'].fadeOut();
                this.enterStory(4);
            }
        }
    }


    update(player: player.Player) {
        for (var key in this.messages) {
            this.messages[key].update();
        }

        if (this.startx == -1) {
            this.startx = player.player.body.x;
        }

        if (this.phase == 0) {
            if (this.story == 0) {
                if (player.player.body.x - this.startx > 50 && player.player.body.velocity.x > 1) {
                    this.messages['move'].fadeOut();
                    this.messages['jump'].fadeIn();
                    this.enterStory(1);
                }
            }
            else if (this.story == 1) {
                if (player.player.body.velocity.y > 1) {
                    this.messages['jump'].fadeOut();
                    this.enterStory(2);
                }
            }

        }
    }

}

class Message {
    game: Phaser.Game;
    parent: Phaser.Group;
    container: Phaser.Group;

    text: i18n.Text;
    pointer: Phaser.Sprite | null;
    fadingIn: boolean;
    fadingOut: boolean;
    activeTween: Phaser.Tween | null;

    constructor(game:Phaser.Game, group: Phaser.Group, text:string, x:number, y:number, sx?:number, sy?:number){
        this.game = game;
        this.parent = group;
        this.container = this.game.add.group(this.parent);

        this.text = i18n.label(this.game, x, y, text, "font-small", 24);
        this.container.add(this.text);
        this.text.anchor.setTo(0.5, 0.5);
        this.text.align = "center";

        if (sx != null && sy != null) {
            this.pointer = this.game.add.sprite(sx, sy, "pointer");
            this.pointer.anchor.setTo(0.5, 0.46);
            this.pointer.alpha = 0.5;
            this.pointer.inputEnabled = true;

            let tween: Phaser.Tween | null = null;
            this.pointer.events.onInputOver.add(() => {
                if (tween) tween.stop();
                tween = this.game.add.tween(this.pointer!.scale).to({
                    x: 1.25,
                    y: 1.25,
                }, 300).start();
                this.pointer!.tint = 0x00FF00;
            });
            this.pointer.events.onInputOut.add(() => {
                if (tween) tween.stop();
                tween = this.game.add.tween(this.pointer!.scale).to({
                    x: 1,
                    y: 1,
                }, 300).start();
                this.pointer!.tint = 0xFFFFFF;
            });

            this.container.add(this.pointer);
        }
        else {
            this.pointer = null;
        }

        this.container.alpha = 0;
    }

    fadeIn() {
        const tween = this.game.add.tween(this.container).to({
            alpha: 1,
        }, 300, Phaser.Easing.Cubic.InOut);
        tween.onComplete.add(() => {
            this.activate();
        })
        tween.start();
    }

    fadeOut() {
        if (this.activeTween) this.activeTween.stop();
        const tween = this.game.add.tween(this.container).to({
            alpha: 0,
        }, 300, Phaser.Easing.Cubic.InOut).start();
    }

    activate() {
        if (this.pointer) {
            this.pointer.alpha = 0.5;
            const tween = this.game.add.tween(this.pointer).to({
                alpha: 1,
            }).loop().yoyo(true).start();
            this.activeTween = tween;
        }
    }

    containsPoint(point: collision.PointLike): boolean {
        if (this.pointer) {
            return this.pointer.getBounds().contains(point.x, point.y);
        }
        return false;
    }

    update(){
    }
}



// WEBPACK FOOTER //
// ./src/tutorial.ts